var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/index.ts
import { customAlphabet } from "nanoid";
function createUniqueId() {
  return customAlphabet("123456789abcdefghijkmnopqrstuvwxyz")(12);
}
__name(createUniqueId, "createUniqueId");
export {
  createUniqueId
};
/*! For license information please see index.mjs.LEGAL.txt */
//# sourceMappingURL=index.mjs.map
